export default __webpack_public_path__ + "static/media/SantiagoBrunet.dda1dd91.png";